import React from 'react'

import { shape, number, bool } from 'prop-types'

import { formatMoneyValue } from '../../../formatter'
import { PAYOUT_RATE_ARTICLE_URL } from '../../../Static/constants'

function PayoutRateBanner({ payoutRate = null, showArticleLink = false }) {
  const {
    rate, isCustom, amountToNext, nextRate, levelId,
  } = payoutRate || {}

  const showNextLevel = payoutRate && !isCustom && levelId < 26

  return (
    <div className="overview-payout-banner cgt-text-medium">
      <span className="overview-payout-banner__info">
        {'Your payout rate: '}
        <span className="overview-payout-banner__rate cgt-text-medium--semi-bold">
          {rate != null ? `${rate}%` : '-'}
        </span>
        {showNextLevel && (
          <span>
            {' \u00B7 Sell '}
            <span className="overview-payout-banner__amount cgt-text-medium--semi-bold">
              ${formatMoneyValue(amountToNext)}
            </span>
            {' more to reach '}
            <span className="cgt-text-medium--semi-bold">{nextRate}%</span>
          </span>
        )}
      </span>
      {showArticleLink && (
        <a
          className="overview-payout-banner__link cgt-link-primary"
          href={PAYOUT_RATE_ARTICLE_URL}
          target="_blank"
          rel="noreferrer"
        >
          How rates are calculated
        </a>
      )}
    </div>
  )
}

PayoutRateBanner.propTypes = {
  payoutRate: shape({
    rate: number.isRequired,
    isCustom: bool.isRequired,
    amountToNext: number.isRequired,
    nextRate: number.isRequired,
    levelId: number.isRequired,
  }),
  showArticleLink: bool,
}

export default PayoutRateBanner
